import React from 'react';
import { motion } from 'framer-motion';
import { HardHat, HeartPulse, Factory, Building2, Truck, UtensilsCrossed, ShoppingBag, Tractor } from 'lucide-react';
const industries = [{
  name: 'Construction',
  icon: HardHat,
  image: 'https://images.unsplash.com/photo-1532073150508-0c1df022bdd1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=90'
}, {
  name: 'Healthcare',
  icon: HeartPulse,
  image: 'https://images.unsplash.com/photo-1582719471384-894fbb16e074?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=90'
}, {
  name: 'Manufacturing',
  icon: Factory,
  image: 'https://images.unsplash.com/photo-1565120130276-df567208f71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=90'
}, {
  name: 'Public Sector',
  icon: Building2,
  image: 'https://images.unsplash.com/photo-1555841436-3b9eef6ce89a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=90'
}, {
  name: 'Transportation',
  icon: Truck,
  image: 'https://images.unsplash.com/photo-1519003722824-194d4455a60c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=90'
}, {
  name: 'Hospitality',
  icon: UtensilsCrossed,
  image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=90'
}, {
  name: 'Retail',
  icon: ShoppingBag,
  image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=90'
}, {
  name: 'Agriculture',
  icon: Tractor,
  image: 'https://images.unsplash.com/photo-1592982537443-d1e420869ba3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=90'
}];
export function Industries() {
  return <section className="py-24 bg-white border-t border-gray-100" data-id="element-212">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-214">
          <h2 className="text-brand-gold font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-215">
            Industries We Serve
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-brand-navy mb-6" data-id="element-216">
            Expertise across every sector
          </h3>
          <p className="text-lg text-gray-600" data-id="element-217">
            We understand the unique risks, physical demands, and return-to-work
            challenges inherent to different industries.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-218">
          {industries.map((ind, index) => {
          const Icon = ind.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative h-64 rounded-xl overflow-hidden group cursor-pointer" data-id="element-219">
                {/* Background Image */}
                <img src={ind.image} alt={`${ind.name} industry workers`} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-220" />

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/90 via-brand-navy/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" data-id="element-221"></div>

                {/* Content */}
                <div className="absolute inset-0 p-6 flex flex-col justify-end" data-id="element-222">
                  <Icon className="w-8 h-8 text-brand-gold mb-3 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-223" />
                  <h4 className="text-xl font-serif font-bold text-white transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300" data-id="element-224">
                    {ind.name}
                  </h4>
                  <div className="h-0.5 w-12 bg-brand-gold mt-4 transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" data-id="element-225"></div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}